/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const deleteEventSubscriptionPathParamsSchema = z.object({
    "id": z.string().describe("Event subscription identifier")
    })

export const deleteEventSubscriptionHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Event subscription owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Event subscription deleted
 */
export const deleteEventSubscription204Schema = z.any()

/**
 * @description Event subscription not found
 */
export const deleteEventSubscription404Schema = z.any()

export const deleteEventSubscriptionMutationResponseSchema = z.lazy(() => deleteEventSubscription204Schema)